import styled from 'styled-components';

export const SliderText = styled.span`
  text-align: center;
  width: 48px;
  color: ${props => props.theme.fontColors.white};
  opacity: 0.5;
  letter-spacing:${props=>props.theme.letterSpacing.slider};
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  transition: all 0.36s cubic-bezier(0.78, 0.14, 0.15, 0.86);
`;

export const Slider = styled.span`
  position: relative;
  width: 105px;
  height: 26px;
  display: flex;
  align-items: center;
  padding: 0;
  font-size: ${props => props.theme.fontSize.secondary};
  background-color: ${props => props.theme.backgroundColor.primaryColor};
  border-radius: 100px;
  transition: all 0.36s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  &::before {
    position: absolute;
    content: '${props => (props.filterType === 'List' ? 'List' : 'Grid')}';
    height: 20px;
    width: 56px;
    color: ${props => props.theme.backgroundColor.primaryColor};
    background-color: ${props => props.theme.fontColors.white};
    font-size: ${props => props.theme.fontSize.secondary};
    font-family:  ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
    transition:right 1s linear;
    display: flex;
    letter-spacing:${props=>props.theme.letterSpacing.slider};
    align-items: center;
    justify-content: center;
    transform: translate(4px, 0);
    border-radius: 18px;
    transition: all 0.36s cubic-bezier(0.78, 0.14, 0.15, 0.86);
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      top: 13%;
    }
  }
`;

export const Switch = styled.label`
  display: inline-block;
  width: inherit;
  vertical-align: middle;
  & input {
    display: none;
    &:checked + ${Slider}::before {
      transition: all 0.36s cubic-bezier(0.78, 0.14, 0.15, 0.86);
      transform: translate(45px, 0);
      -ms-transform: translate(45px, 0);
      -webkit-transform: translate(45px, 0);
      -moz-transform: translate(45px, 0);
      -o-transform: translate(45px, 0);
      position: absolute;
    }
    &:not(:checked) + ${Slider} ${SliderText} {
      position: absolute;
      /* right: 4px; */
      right: 1px;
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        top: 10%;
      }
    }
  }
`;
